import { Wording } from '@/types';

export const ASTROLOGY_WORDING_HR: Wording = {
  components_header_media_content: 'Audio zapisi',
  components_header_media_1: 'Meditacije',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Vodiči',
  components_header_text2: 'Blog',
  components_header_members: 'Članovi',
  hero_text: 'Istražite zvijezde u sebi',
  hero_button_text: 'Počnite ovdje',
  components_ressources_section_title: 'RESURSI',
  components_ressources_subheader_text: 'Svi alati koji su vam potrebni za kozmički uvid i samospoznaju',
  components_ressources_span_text: 'Proširite svoj unutarnji svemir odabranom mješavinom podcasta i članaka. Tražite li kozmički uvid, jasnoću ili duhovno usklađivanje, naši resursi pomažu vam da se povežete s astrologijom na praktične i smislene načine.',
  components_ressources_card_1_title: 'Dubinske analize',
  components_ressources_card_1_text: 'Zaronite u bogatu kolekciju detaljnih podcasta koji pokrivaju astrologiju, tarot, kozmičke arhetipove i duhovni rast – osmišljenih da prošire vašu svijest i prodube vašu praksu.',
  components_ressources_card_2_title: 'Zvjezdani uvidi',
  components_ressources_card_2_text: 'Astrološki savjeti i blog postovi za samosvijest i duhovni rast.',
  components_ressources_link: 'Istražite dalje',
  components_notes_and_google_title_1: 'Astrološko vodstvo',
  components_notes_and_google_title_2: 'Kozmička rutina',
  components_notes_and_google_title_3: 'Razmišljanja',
  components_review_google_text: 'Recenzije',
  media_content_section_title: 'ZVUKOVI',
  media_content_section_subheader_text: 'Naš podcast',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Više epizoda',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Članci i uvidi',
  text2_section_button_more: 'Učitaj više',
  components_text1_section_title: 'VODIČI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Prikaži sve vodiče',
  components_footer_text: 'Probudite svoj unutarnji kozmos: Vaš put, vaše zvijezde.',
  components_footer_info: 'Informacije',
  components_footer_registration_number: 'Registarski broj',
  components_footer_legal: 'Pravno',
  components_footer_terms: 'Uvjeti i odredbe',
  components_footer_privacy: 'Pravila o privatnosti',
  button_load_more: 'Učitaj više',
  page_media_1_content_hero_text: 'Epizode podcasta',
  page_media_content_menu_foundations: 'Temelji',
  page_media_content_menu_spirituality: 'Duhovnost',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psihologija',
  page_media_content_menu_trends: 'Trendovi',
  page_media_2_content_hero_text: 'Mediji 2',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: '',
  enter_email_placeholder_email: '',
  enter_email_button_enter: '',
  components_login_success_text: '',
  components_card_link_media_content: '',
  components_card_link_text1_content: '',
  components_card_link_text2_content: '',
  france: '',
  cyprus: '',
  tag_podcast: '',
  tag_meditation: '',
  page_media_content_menu_all: 'Sve',
};